import { createFileRoute } from '@tanstack/react-router';
import { DeletedEngagementsScreen } from '@/components/settings/deleted-engagements-screen';

/**
 * Firm settings → Deleted engagements (T-0161). Firm admins only; the
 * settings navigation shows the entry only to them, and the screen itself
 * calls nothing for anyone else.
 */
export const Route = createFileRoute('/settings/deleted-engagements')({
  component: DeletedEngagementsScreen,
});
